import { apiRequest } from "../api/client";

export interface NotificationItem {
  id: number;
  category: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  title: string;
  message: string;
  action_url?: string;
  event_type?: string;
  idempotency_key?: string;
  status: 'unread' | 'read' | 'archived' | 'deleted';
  created_at: string;
}

export interface AnnouncementItem {
  id: number;
  title: string;
  content: string;
  target_type: string;
  priority: string;
  created_at: string;
}

export interface ReminderItem {
  id: number;
  title: string;
  category: string;
  due_at: string;
  is_completed: boolean;
}

export const notificationApi = {
  getSummary: async () => {
    return apiRequest<any>("/notifications/console/summary/");
  },
  getInbox: async (): Promise<NotificationItem[]> => {
    return apiRequest<NotificationItem[]>("/notifications/inbox/");
  },
  markRead: async (id: number) => {
    return apiRequest<any>(`/notifications/inbox/${id}/mark_read/`, "POST");
  },
  markAllRead: async () => {
    return apiRequest<any>("/notifications/console/mark_all_read/", "POST");
  },
  getAnnouncements: async (): Promise<AnnouncementItem[]> => {
    return apiRequest<AnnouncementItem[]>("/notifications/announcements/");
  },
  broadcastAnnouncement: async (data: { title: string; content: string; target_type?: string; priority?: string }) => {
    return apiRequest<any>("/notifications/console/broadcast/", "POST", data);
  },
  getReminders: async (): Promise<ReminderItem[]> => {
    return apiRequest<ReminderItem[]>("/notifications/reminders/");
  },
  createReminder: async (data: Partial<ReminderItem>): Promise<ReminderItem> => {
    return apiRequest<ReminderItem>("/notifications/reminders/", "POST", data);
  },
  getPreferences: async () => {
    return apiRequest<any[]>("/notifications/preferences/");
  },
  getTemplates: async () => {
    return apiRequest<any[]>("/notifications/templates/");
  },
};

export default notificationApi;
